import TextInput from "components/common/custom/forms/BootTextField/TextField";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleBranchFilter } from "../config/branchSlice";

const BranchListFilters = ({ watch, control, setValue }) => {
  const { branchFilters } = useSelector((state) => state.branch);
  const dispatch = useDispatch();
  const handleName = (selected) => {
    setValue("name", selected);
    dispatch(handleBranchFilter({ check: "name", value: selected }));
  };
  const handleCCHINo = (selected) => {
    setValue("cchi_no", selected);
    dispatch(handleBranchFilter({ check: "cchi", value: selected }));
  };
  const handleNphiesID = (selected) => {
    setValue("nphies_id", selected);
    dispatch(handleBranchFilter({ check: "nphies_id", value: selected }));
  };

  useEffect(() => {
    setValue("name", branchFilters?.name);
    setValue("cchi_no", branchFilters?.cchi);
    setValue("nphies_id", branchFilters?.nphies_id);
  }, []);

  return (
    <Row>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="name"
          label="Name"
          placeholder="Name"
          onChange={(value) => handleName(value)}
          control={control}
          size="sm"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="cchi_no"
          label="CCHI No"
          placeholder="CCHI No"
          onChange={(value) => handleCCHINo(value)}
          control={control}
          size="sm"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="nphies_id"
          label="Nphies ID"
          placeholder="Nphies ID"
          onChange={(value) => handleNphiesID(value)}
          control={control}
          size="sm"
        />
      </Col>
    </Row>
  );
};

export default BranchListFilters;
